import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSparkles2Bold: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSparkles2Bold"><Path d="M14.7002 7L16.4502 11.5498L21 13.2998V14.7002L16.4502 16.4502L14.7002 21H13.2998L11.5498 16.4502L7 14.7002V13.2998L11.5498 11.5498L13.2998 7H14.7002Z" fill="currentColor"/><Path d="M7.40039 3L8.40039 5.59961L11 6.59961V7.40039L8.40039 8.40039L7.40039 11H6.59961L5.59961 8.40039L3 7.40039V6.59961L5.59961 5.59961L6.59961 3H7.40039Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSparkles2Bold;
